import {
  ApplicationConfig,
  importProvidersFrom,
  inject,
  LOCALE_ID,
  provideAppInitializer,
  provideZoneChangeDetection,
} from '@angular/core';
import { OverlayContainer } from '@angular/cdk/overlay';
import {
  HttpClient,
  provideHttpClient,
  withInterceptors,
} from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';

import { provideNgxMask } from 'ngx-mask';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import {
  PU_CONFIG,
  PU_TOAST_CONFIG,
  PU_TOAST_DEFAULT_CONFIG,
  SPINNER_COMPONENT,
} from '@hglobal/common';
import { environment } from '@fb/environments';

import { CdkOverlayContainer } from './services/overlay/overlay-container';
import { authWithCredentialsInterceptor } from './services/auth/auth-with-credentials.interceptor';
import { TranslateLoaderService } from './services/translation/translate-loader.service';
import { TranslationPathService } from './services/translation/translation-path.service';
import { SpinnerComponent } from './components/spinner/spinner.component';
import { refreshTokenInterceptor } from './services/auth/refresh-token.interceptor';
import { GrowthBookService } from './services/growth-book/growth-book.service';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideAppInitializer(() => inject(GrowthBookService).init()),
    { provide: OverlayContainer, useClass: CdkOverlayContainer },
    provideNgxMask(),
    provideHttpClient(
      withInterceptors([
        refreshTokenInterceptor,
        authWithCredentialsInterceptor,
      ]),
    ),
    provideAnimations(),
    importProvidersFrom(
      TranslateModule.forRoot({
        defaultLanguage: 'en',
        loader: {
          provide: TranslateLoader,
          useClass: TranslateLoaderService,
          deps: [HttpClient],
        },
      }),
    ),
    TranslationPathService,
    { provide: LOCALE_ID, useValue: 'en' },
    {
      provide: PU_TOAST_CONFIG,
      useValue: PU_TOAST_DEFAULT_CONFIG,
    },
    {
      provide: PU_CONFIG,
      useValue: {
        apiHost: environment.apiHost,
        useMocks: environment.useMocks,
        production: environment.production,
        mfePrefix: environment.assetsUrl,
      },
    },
    {
      provide: SPINNER_COMPONENT,
      useValue: SpinnerComponent,
    },
    {
      provide: PU_CONFIG,
      useValue: { useNewIcons: true },
    },
  ],
};
